// const BASE_URL = import.meta.env.DEV
//   ? 'http://localhost:4000'
//   : 'http://localhost:4000';

// export default BASE_URL;




const BASE_URL = import.meta.env.DEV
  ? 'http://localhost:4000'
  : 'https://enlytical-backend-po-dot-famous-archway-436113-a8.el.r.appspot.com';

export default BASE_URL;
